'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFlipToFront = function MdFlipToFront(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11.6 35v-3.4h3.4v3.4h-3.4z m6.8 0v-3.4h3.2v3.4h-3.2z m13.2-10v-16.6h-16.6v16.6h16.6z m0-20q1.4 0 2.4 1t1 2.4v16.6q0 1.3-1 2.3t-2.4 1.1h-16.6q-1.4 0-2.4-1.1t-1-2.3v-16.6q0-1.4 1-2.4t2.4-1h16.6z m-6.6 30v-3.4h3.4v3.4h-3.4z m-20-20v-3.4h3.4v3.4h-3.4z m3.4 20q-1.4 0-2.4-1t-1-2.4h3.4v3.4z m-3.4-6.6v-3.4h3.4v3.4h-3.4z m0-6.8v-3.2h3.4v3.2h-3.4z' })
        )
    );
};

exports.default = MdFlipToFront;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/flip-to-front.js
// module id = 755
// module chunks = 0